import { BACKEND } from "../variables.js";
import axios from "axios";

const CREATE_ACTION_REQUEST = BACKEND + "/adminActionRequests/create";
const LIST_BY_HOUSE = BACKEND + "/adminActionRequests/listByHouse";
const LIST_BY_TENANT = BACKEND + "/adminActionRequests/listByTenant";
const APPROVE = BACKEND + "/adminActionRequests/approve";
const REJECT = BACKEND + "/adminActionRequests/reject";
const PERMISSION_MAP = BACKEND + "/adminActionRequests/permissionMap";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    CREATE_ACTION_REQUEST(state, payload) {
      return axios({
        method: "POST",
        url: CREATE_ACTION_REQUEST,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    LIST_ACTION_REQUESTS_BY_HOUSE(state, payload) {
      return axios({
        method: "POST",
        url: LIST_BY_HOUSE,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    LIST_ACTION_REQUESTS_BY_TENANT(state, payload) {
      return axios({
        method: "POST",
        url: LIST_BY_TENANT,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    APPROVE_ACTION_REQUEST(state, payload) {
      return axios({
        method: "POST",
        url: APPROVE,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    REJECT_ACTION_REQUEST(state, payload) {
      return axios({
        method: "POST",
        url: REJECT,
        data: payload.data,
        headers: { Authorization: payload.token },
      });
    },
    GET_ACTION_REQUESTS_PERMISSION_MAP(state, payload) {
      return axios({
        method: "GET",
        url: PERMISSION_MAP,
        headers: { Authorization: payload.token },
      });
    },
  },
};
